<template>
  <div class="nasabah">
    <p class="title">Nasabah Terdaftar</p>
    <div class="content">
      <div class="table-responsive">
        <table class="table table-striped table-bordered" id="my-table">
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Lengkap</th>
              <th>Tempat/Tanggal Lahir</th>
              <th>Status Kewarganegaraan</th>
              <th>No Telepon</th>
              <th>NPWP</th>
              <th>No Identitas</th>
              <th class="action">Action</th>
            </tr>
          </thead>
          <tbody v-if="lengthData">
            <td colspan="9" v-show="loadingData" style="text-align: center">
              <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </td>
            <tr v-for="(data, i) in dataNsb" :key="i" v-show="loadingData == false">
              <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
              <td>{{ data.personal_data[0].full_name ? data.personal_data[0].full_name : "-" }}</td>
              <td>
                {{ data.personal_data[0].place_of_birth ? data.personal_data[0].place_of_birth : "-" }},
                {{ data.personal_data[0].birthday | formatDate }}
              </td>
              <td>{{ data.personal_data[0].citizenship ? data.personal_data[0].citizenship : "-" }}</td>
              <td>{{ data.personal_data[0].phone_number ? data.personal_data[0].phone_number : "-" }}</td>
              <td>{{ data.personal_data[0].npwp ? data.personal_data[0].npwp : "-" }}</td>
              <td>{{ data.personal_data[0].identity_owner ? data.personal_data[0].identity_owner : "-" }}</td>
              <td>
                <router-link :to="'/nsb-detail/' + data._id"
                  ><button type="button" class="buttons btn-info btn-xs">
                    Detail
                  </button></router-link
                >
                <button type="button" class="buttons btn-danger btn-xs" @click="sendId(data._id)" data-toggle="modal" data-target="#exampleModal">
                  Blacklist
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="8" style="text-align: center">
                No Data
              </td>
            </tr>
          </tbody>
        </table>
        <b-pagination
          v-model="currentPage"
          :total-rows="count_data"
          :per-page="perPage"
          aria-controls="my-table"
          @change="handlePageChange"
          v-show="count_data > perPage"
        ></b-pagination>
      </div>
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Blacklist Nasabah Terdaftar
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="blacklist">
              <div class="modal-body">
                Apakah Anda yakin memasukan akun tersebut ke dalam daftar blacklist?
                <textarea name="input message" placeholder="Berikan alasan ke nasabah" rows="4" v-model="messageNasabah"></textarea>
              </div>
              <div class="modal-footer">
                <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                <button type="submit" class="btn-primer" aria-hidden="true">
                  <span v-show="!isLoading">Setuju</span>
                  <Loading v-show="isLoading" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../assets/Loading.vue";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      dataNsb: [],
      id: "",
      currentPage: 1,
      perPage: 10,
      number: 1,
      messageNasabah: "",
      lengthData: 1,
      loadingData: false,
      hiddenCards: [],
      idToggle: null,
      showToggle: false,
      count_data: "",
      isLoading: false,
    };
  },

  mounted() {
    this.getData(this.currentPage);
  },
  methods: {
    handlePageChange(value) {
      this.getData(value);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    getData(value) {
      this.loadingData = true;
      let offset = (value - 1) * this.perPage;
      let url;
      let role = localStorage.getItem("role");
      if (role == "0") {
        url = "superadmin";
      } else {
        url = "admin-broker";
      }
      axios
        .get("/v2/" + url + "/kyc/customers?status=3&limit=5&offset=" + offset)
        .then((res) => {
          this.count_data = res.data.data.count;
          this.dataNsb = res.data.data.nasabah;
          this.loadingData = false;
          if (this.dataNsb == 0) {
            this.lengthData = 0;
          } else {
            this.lengthData = this.dataNsb.length;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loadingData = false;
        });
    },

    toggle(e) {
      if (this.idToggle == e) {
        this.idToggle = null;
      } else {
        this.idToggle = e;
      }
    },
    blacklist() {
      this.isLoading = true;
      axios
        .put("/v1/nasabah/blacklist/" + this.id, {
          description: this.messageNasabah,
        })
        .then((res) => {
          this.isLoading = false;
          if (res.status == 200) {
            this.$notify({
              group: "foo",
              title: "<h5>Blacklist user berhasil</h5>",
              type: "success",
            });

            // location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendId(id) {
      this.id = id;
      // console.log(this.id)
    },
  },
  computed: {
    checkRole() {
      let role = localStorage.getItem("role");
      if (role) {
        return role;
      } else {
        return null;
      }
    },
    rows() {
      return this.count_data;
    },
    paginate() {
      if (!this.dataNsb || this.dataNsb.length != this.dataNsb.length) {
        return;
      }
      var like = this;

      like.resultCount = this.dataNsb.length;
      if (this.currentPage >= this.totalPages) {
        like.currentPage = this.totalPages;
      }
      var index = this.currentPage * this.perPage - this.perPage;
      return this.dataNsb.slice(index, index + this.perPage);
    },
  },
};
</script>

<style scoped>
.wrap-dropdown {
  position: relative;
}

.dropdown-link {
  display: block;
  position: absolute;
  right: 160px;
  background: #fff;
  top: -23px;
  padding: 10px 15px;
}

.dropdown-link li {
  height: 35px;
  margin-bottom: 5px;
  line-height: 2.5;
  cursor: pointer;
}

.icon-toggle {
  cursor: pointer;
}

.lds-ring {
  display: inline-block;
  /* position: absolute; */
  width: 30px;
  height: 30px;
  /* top: 4px; */
  /* left: 39%; */
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  margin: 6px;
  border: 6px solid #1f354a;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #1f354a transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

table {
  color: #707070 !important;
}

.nasabah {
  font-size: 14px;
  padding: 0 20px;
}

.title {
  font-size: 22px;
  font-weight: bold;
  margin: 0 0 60px;
}

.action {
  width: 186px;
}
</style>
